import { InjectionToken } from '@angular/core';
import { AppConfig } from './app-config.interface';

export const appConfigService = new InjectionToken<AppConfig>('AppConfig');
